import formatValue from "../../../Utils/ListUtils/FormatValue";
import request from "../../../Services/API/Requests";
import asyncForEach from "../../../Utils/Form/FormDynamic/Utils/asyncForEach";
import {loginSystem, returnListProps, transformListProps} from "./lib";
import findByString from "../../../Utils/Form/FormDynamic/Utils/getValueByString";

//reserved variable names, will replace with varName+ "_Reserved" postfix
const reservedNames = ['import', 'export', 'var', 'const', 'list'];

//find in string {...} to define what param should execute with eval
export function findParams(string = "", globalValues, screenName, actions, escapeHtmlParams, generatedScript) {
    let countOpen = 0;
    let countClose = 0;
    let a = [];
    let objectValues = {};
    let params = [];
    if (!string) return {params, objectValues}
    for (let i = 0; i < string.length; i++) {
        if (typeof string === "string") {
            if (string.charAt(i) === '{') {
                countOpen += 1;
                a.push(i)
            }
            if (string.charAt(i) === '}') {
                countClose += 1
            }
            if (countOpen > 0 && countOpen === countClose) {
                const param = string.substring(a[0] + 1, i);
                const endParam = string.substring(a[0], i + 1);
                const escapedParam = param.replace(/<[^>]*>?/gm, '');
                // const escapedEndParam = endParam.replace(/<[^>]*>?/gm, '');
                // console.log(escapedParam, '.........', param, '.........', escapedEndParam);
                params.push(param);
                objectValues[endParam] = executor(escapeHtmlParams ? escapedParam : param, globalValues, screenName, actions, generatedScript);
                countClose = 0;
                countOpen = 0;
                a = []
            }
        }
    }
    return {params, objectValues};
}

//eval executor
export function executor(params, globalValues = {}, screenName, actions = {}, generatedScript) {
    /* eslint-disable */
    let getSafeValues = getSafe;
    let findValueByString = findByString;
    let getArr = (arr = [], key) => arr.map(el => el[key]);
    const formatData = formatValue;
    const sendRequest = async (req) => {
        let reqData = req.data;
        if (reqData) {
            reqData = await replaceBlobStrings(req.data);
        }
        return request({url: req.url, method: req.method, data: reqData, api: req.api})
    };
    const asyncFor = asyncForEach;
    const today = calculateDate;
    const showErrorMessages = (err, showFields) => showErrorMsgs(err, showMessage, showFields);
    const fileByLink = getFileByLink;

    function requestWithFiles(req) {

    }

    function openPdf(blob) {
        let iframe = "<title>TEst</title></titl><style>body {overflow: hidden; margin: 2px !important; padding: 0 !important;}</style><embed name='plugin' width='100%' height='100%' src='" + blob + "'></embed>"
        let x = window.open();
        x.document.open();
        x.document.write(iframe);
        x.document.close();
    }

    async function getMyLocation() {
        return await new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(
                (location) => {
                    resolve([location.coords.latitude, location.coords.longitude])
                },
                (error) => {
                    reject('Get geolocation error');
                }
            )
        })
    }

    //application actions available inside script
    let {
        setVariable, showMessage, cancel, setFilter, startProcess, completeTask, deleteTask,
        refreshData, returnValue, setLoading, disableAllFields, nextScreen, fetchApplication, setSessionStorage,
        toggleSidebar, setUserLanguage, setListData, downloadFile, setSidebarState, setPivot, clearFile, listUncheckAll,
        cameraScreenshot, getElementById, uploadFile, htmlToPng, setFormData, openPopup, enableAllFields
    } = actions;
    const list = (listID) => returnListProps(listID, globalValues.list, listUncheckAll);
    let globalValuesKeys = Object.keys(globalValues || {});
    let globalVariables = [];
    let doc = null;
    let replaceVariables = checkForInParam(params, screenName);
    let replaceGeneratedScript = checkForInParam(generatedScript || "", screenName);
    const login = async ({username, password}) => await loginSystem({
        username,
        password
    }, fetchApplication, nextScreen, setSidebarState, setSessionStorage)

    //collect all available variables from globalValues, to get it in eval string
    globalValuesKeys.forEach(item => {
        if (item && globalValues.hasOwnProperty(item)) {
            if (item === 'param') {
                const paramArray = Object.keys(globalValues[item] || {});
                paramArray.forEach(paramItem => {
                    const screenParamsArray = Object.keys(globalValues[item][paramItem] || {});
                    screenParamsArray.forEach(screenParam => {
                        collectVariables(globalValues[item][paramItem], screenParam)
                    })
                })
                return
            }
            collectVariables(globalValues, item)
        }
    })

    function collectVariables(globalValues, item) {
        if (item && globalValues.hasOwnProperty(item)) {
            if (item !== 'doc') {
                let itemName = reservedNames.includes(item) ? item + '_Reserved' : item;
                let variable = `var ${itemName} = `
                let value;
                switch (typeof globalValues[item]) {
                    case 'object':
                        value = JSON.stringify(globalValues[item])
                        break;
                    case 'string':
                        if (item === '_preScript') {
                            value = JSON.stringify({});
                        } else {
                            value = `\`${globalValues[item]}\``
                        }

                        break;
                    case 'number':
                        value = Number(globalValues[item])
                        break;
                    default:
                        value = globalValues[item]
                        break
                }
                globalVariables.push(variable + value)
            }
        }
    }

    if (globalValues.doc) {
        doc = globalValues.doc
    }
    replaceVariables = globalVariables.join('\n') + '\n\n' + replaceGeneratedScript + '\n' + replaceVariables;
    try {
        return eval(replaceVariables)
    } catch (e) {
        process.env.NODE_ENV === 'development' ? console.error(`%c${e}`, 'background: #222; color: #bada55') : ""
    }
}

function checkForInParam(newString, screenName) {
    let param = newString.replace(/inParam/g, `inParam.${screenName}`);
    if (reservedNames.includes(param)) param = param + '_Reserved'
    return param;
}

function getSafe(fn, defaultVal) {
    try {
        if (fn() === undefined || fn() === null) {
            return defaultVal
        }
        return fn();
    } catch (e) {
        return defaultVal;
    }
}

function scapeHtmlTags(html) {
    let tmp = document.createElement("DIV");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || " ";
    // return str.replace(/<[^>]*>?/gm, '');
}

function calculateDate(days = 0) {
    let today = new Date();
    let result = new Date().setDate(today.getDate() + days);
    return formatValue(result, "date", 'YYYY-MM-DD');
}

function showErrorMsgs(err, showMessage, ignoreErrorFields) {
    let errors = getSafe(() => err.data.status.message, []);
    errors.forEach(err => {
        if(ignoreErrorFields && err.field) return;
        showMessage({msgType: err.type, value: `${err.field ? err.field+": " : ""} ${err.text}`})
    })
}

function getFileByLink() {
    return {
        getFile: async (url, readyFile) => {
            return await fetch(url)
                .then(r => r.blob())
                .then(async blobFile => {
                    let file = {};
                    let reader = new FileReader();
                    reader.readAsDataURL(blobFile);
                    await new Promise(resolve => {
                        reader.onload = () => {
                            file = {
                                name: readyFile.name,
                                type: readyFile.type,
                                content: reader.result,
                                refId: readyFile.refId,
                                refEntity: readyFile.refEntity,
                                sharedWith: readyFile.sharedWith,
                                signedBy: readyFile.signedBy
                            };
                            resolve();
                        }
                    })
                    return file
                })
        },
        removeFile: (url) => {
            URL.revokeObjectURL(url)
        }
    }
}

async function getFile(url) {
    return await fetch(url)
        .then(r => r.blob())
        .then(async blobFile => {
            let file = {};
            let reader = new FileReader();
            reader.readAsDataURL(blobFile);
            await new Promise(resolve => {
                reader.onload = () => {
                    console.log(reader.result)
                    file = {
                        content: reader.result,
                    };
                    resolve();
                }
            })
            return file.content
        })
}

async function replaceBlobStrings(obj) {
    const prefix = "blob:";

    async function traverseAndReplace(value) {
        if (typeof value === "string" && value.startsWith(prefix)) {
            return await getFile(value); // Replace the string
        } else if (Array.isArray(value)) {
            return await Promise.all(value.map(item => traverseAndReplace(item))); // Process each array item asynchronously
        } else if (typeof value === "object" && value !== null) {
            const entries = await Promise.all(
                Object.entries(value).map(async ([key, val]) => [
                    key,
                    await traverseAndReplace(val),
                ])
            );
            return Object.fromEntries(entries);
        }
        return value; // Return unchanged value
    }

    return await traverseAndReplace(obj);
}